import React from "react";
import { useNavigate } from "react-router";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";

import GenerateReport from "../../views/favoriteReport/GenerateReport";
import useRoles from "../../hooks/user/useRoles";

export default function FavouriteReportActions({
  entity,
  selectedClientId,
  selectedProjectId,
  showSettings = true,
  duplicateLabel = "Duplicate Template",
}) {
  const navigate = useNavigate();
  const item = entity;
  const canEditTemplate = useRoles(["admin", "manager", "billing_user", "inventory", "client"]);

  const handleDuplicate = (popupState) => {
    navigate(`/projects/${entity.projectId}/templates/duplicate/${entity.id}`);
    popupState.close();
  };

  const handleEdit = (popupState) => {
    navigate(`/projects/${entity.projectId}/templates/${entity.id}`);
    popupState.close();
  };

  const handleSettings = (popupState) => {
    navigate(`/insights?configure=${entity.id}`);
    popupState.close();
  };

  return (
    <>
      <GenerateReport
        entity={entity}
        selectedClientId={selectedClientId}
        selectedProjectId={selectedProjectId}
      />
      {item.payload.receiving_report || item.payload.predefined ? (
        <IconButton disabled style={{ visibility: "hidden" }}>
          <MoreVertIcon />
        </IconButton>
      ) : (
        <PopupState variant="popover" popupId="favourite-report-actions-menu">
          {(popupState) => (
            <>
              <Tooltip title="More Options" arrow>
                <IconButton aria-label="more actions" {...bindTrigger(popupState)}>
                  <MoreVertIcon />
                </IconButton>
              </Tooltip>
              <Menu
                id="favourite-report-actions-menu"
                {...bindMenu(popupState)}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                {canEditTemplate && (
                  <MenuItem onClick={() => handleEdit(popupState)}>
                    <ListItemIcon>
                      <EditOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Edit Template" />
                  </MenuItem>
                )}
                <MenuItem onClick={() => handleDuplicate(popupState)}>
                  <ListItemIcon>
                    <FileCopyOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={duplicateLabel} />
                </MenuItem>
                {showSettings && (
                  <MenuItem onClick={() => handleSettings(popupState)}>
                    <ListItemIcon>
                      <SettingsOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Template Settings" />
                  </MenuItem>
                )}
              </Menu>
            </>
          )}
        </PopupState>
      )}
    </>
  );
}
